"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var markdownTextStyles = makeStyles_1.default(function (_a) {
    var typography = _a.typography;
    return ({
        text: {
            paddingLeft: 10,
            fontSize: typography.fontSM,
        },
    });
}, { name: 'GqlCheckout_MarkdownText' });
exports.default = markdownTextStyles;
